import type { SVGProps } from "react";
export default function SvgUpload(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-upload-icon lucide-upload"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 3v12" />
			<path d="m17 8-5-5-5 5" />
			<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
		</svg>
	);
}
